"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductsPage = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const products_1 = require("../../sections/products");
const ProductsPage = ({ title }) => {
    return (0, jsx_runtime_1.jsx)(products_1.Products, {});
};
exports.ProductsPage = ProductsPage;
